<template>
  <div class="collapse" @click="isShowSearchContent = false">
    <div
      class="hd"
      :class="{
        fold: !configMainShow['keyPerson'],
      }"
      @click="configMainShow['keyPerson'] = !configMainShow['keyPerson']"
    >
      <div class="title-fix">
        <i class="fa-angle-down"></i>
        <span>大哥名单</span>
        <span
          class="el-switch"
          @click.stop="toggleEnable('keyPerson', '大哥名单')"
        >
          <el-switch v-model="configure.keyPerson.enable" disabled></el-switch>
        </span>
      </div>
    </div>
    <div
      class="bd"
      @click="
        isNaN(featureList['keyPerson'].timeRemaining)
          ? shoWDialogBuy(
              featureList['keyPerson']['productKey'],
              '基础包',
              'keyPerson'
            )
          : featureList['keyPerson'].timeRemaining <= 0
          ? showFunctionalRenewal(true)
          : configure.keyPerson.enable
          ? ''
          : toggleEnable('keyPerson', '大哥名单')
      "
      :class="{
        'no-buy': isNaN(featureList['keyPerson'].timeRemaining),
        expired: featureList['keyPerson'].timeRemaining <= 0,
        'shut-off': !configure.keyPerson.enable,
      }"
    >
      <el-row>
        <!-- <el-col :span="19"> -->
        <div class="block-tag">
          大哥叫“书影小熊猫”，备注为“熊猫哥”。欢迎、感谢都会称呼为“熊猫哥”。
        </div>
        <div class="search-container" @click.stop>
          <div class="search-input">
            <el-input
              class="inline-input"
              prefix-icon="el-icon-search"
              v-model.trim="nickname"
              placeholder="请输入大哥昵称或者虎牙号"
              @input="searchInput"
              @keyup.enter.native="searchUser"
              @focus="searchFocus"
            >
            </el-input>
            <el-button size="medium" type="primary" @click="querySearch"
              >搜索添加</el-button
            >
          </div>
          <!-- <div class="search-content">
            <ul class="search-rank-list" v-if="searchKeyPesonList.length">
              <li
                class="rank-item"
                v-for="item in searchKeyPesonList"
                :key="item.uid"
                @click="addKeyPersonList(item)"
              >
                <img class="avatar" :src="item.avatar" alt="" />
                <div class="info">
                  <p class="nickname">{{ item.nickname }}</p>
                  <p>
                    <span
                      class="noble-icon"
                      :class="`noble-level-${item.nobel}`"
                    ></span>
                    <span
                      class="level-icon"
                      :class="`level-icon${item.level}`"
                    ></span>
                  </p>
                </div>
              </li>
            </ul>
            <p v-else class="no-data">无大哥数据</p>
          </div> -->
          <div
            class="search-content"
            :class="{
              show: isShowSearchContent,
            }"
            v-loading="isLoading"
          >
            <div class="person-card-wrap" ref="scroll" @scroll="scrollHandler">
              <person-card
                v-for="item in searchKeyPesonList"
                :key="item.id"
                :user="item"
                @cardClick="addKeyPersonList(item)"
              ></person-card>
            </div>
          </div>
        </div>
        <key-person-table
          ref="keyPerson"
          :currentList="keyPersonList"
          :totalCount="totalCount"
          :ticket="ticket"
          @getKeypersonList="getKeypersonList"
          @delNotice="delNotice"
        ></key-person-table>
        <!-- <div class="row-padding">
          <el-button type="primary" @click="isShowBatchImport = true"
            >批量导入</el-button
          >
        </div> -->
        <!-- </el-col> -->
      </el-row>
      <div class="dash-line"></div>
      <el-row>
        <el-col :span="5"
          >自动加入名单
          <span id="keyPersonBigData" class="hide-anchor-point"></span
        ></el-col>
        <el-col :span="19">
          <!-- <div
            class="block-tag warning"
            v-if="
              isNaN(featureList['bigData'].timeRemaining) ||
                featureList['bigData'].timeRemaining <= 0
            "
          >
            近期消费能力需要「大数据」功能支持。
            <el-link
              class="block-tag-link"
              type="primary"
              :underline="false"
              @click="
                shoWDialogBuy(
                  featureList['bigData']['productKey'],
                  '大数据',
                  'bigData'
                )
              "
              >立即开通</el-link
            >
          </div> -->
          <div>
            <!-- <div
              class="big-data-modules"
              @click="
                isNaN(featureList['bigData'].timeRemaining)
                  ? shoWDialogBuy(
                      featureList['bigData']['productKey'],
                      '大数据',
                      'bigData'
                    )
                  : featureList['bigData'].timeRemaining <= 0
                  ? showFunctionalRenewal(true)
                  : configure.bigData.enable
                  ? ''
                  : toggleEnable('bigData', '大数据')
              "
              :class="{
                'no-buy': isNaN(featureList['bigData'].timeRemaining),
                expired: featureList['bigData'].timeRemaining <= 0,
                'shut-off': !configure.bigData.enable,
              }"
            >
              <el-checkbox
                v-model="configure.keyPerson.newAutoAddOfConsumeEnable"
              ></el-checkbox>
              <span
                @click="
                  configure.keyPerson.newAutoAddOfConsumeEnable = !configure
                    .keyPerson.newAutoAddOfConsumeEnable
                "
              >
                近期消费≥
                <el-select
                  v-model="configure.keyPerson.newAutoAddOfConsumeNum"
                  placeholder="请选择"
                  size="mini"
                >
                  <el-option
                    v-for="item in consumeLevelConfig"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option> </el-select
                >,自动加入大哥名单
              </span>
            </div> -->
            <div class="row-padding">
              <el-checkbox
                v-model="configure.keyPerson.newAutoAddOfFansBadgeEnable"
              ></el-checkbox>
              <span
                @click="
                  configure.keyPerson.newAutoAddOfFansBadgeEnable =
                    !configure.keyPerson.newAutoAddOfFansBadgeEnable
                "
              >
                粉丝牌≥
                <el-input-number
                  v-model="configure.keyPerson.newAutoAddOfFansBadgeLevel"
                  :controls-position="isPC ? 'right' : ''"
                  :min="0"
                  size="mini"
                ></el-input-number
                >级,自动加入大哥名单</span
              >
            </div>
            <div class="row-padding">
              <el-checkbox
                v-model="configure.keyPerson.newAutoAddOfWeekRankEnable"
              ></el-checkbox>
              <span
                @click="
                  configure.keyPerson.newAutoAddOfWeekRankEnable =
                    !configure.keyPerson.newAutoAddOfWeekRankEnable
                "
              >
                周贡榜前
                <el-input-number
                  v-model="configure.keyPerson.newAutoAddOfWeekRank"
                  :controls-position="isPC ? 'right' : ''"
                  :min="0"
                  size="mini"
                ></el-input-number
                >,自动加入大哥名单</span
              >
            </div>
            <div class="row-padding">
              <el-checkbox
                v-model="configure.keyPerson.newAutoAddOfNobleEnable"
              ></el-checkbox>
              <span
                @click="
                  configure.keyPerson.newAutoAddOfNobleEnable =
                    !configure.keyPerson.newAutoAddOfNobleEnable
                "
              >
                贵族等级≥
                <el-select
                  v-model="configure.keyPerson.newAutoAddOfNoble"
                  placeholder="请选择"
                  size="mini"
                >
                  <el-option
                    v-for="item in welcomeConfig"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option> </el-select
                >,自动加入大哥名单</span
              >
            </div>
            <!-- <div class="row-padding">
              <el-checkbox
                v-model="configure.keyPerson.newAutoAddOfInteractAnchorEnable"
              ></el-checkbox>
              <span
                @click="
                  configure.keyPerson.newAutoAddOfInteractAnchorEnable = !configure
                    .keyPerson.newAutoAddOfInteractAnchorEnable
                "
              >
                连麦主播,自动加入大哥名单</span
              >
            </div> -->
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">大哥特权</el-col>
        <el-col :span="19">
          <div class="row-padding">
            <el-switch
              v-model="configure.keyPerson.copyKeyPersonBarrageEnable"
            ></el-switch
            >复制弹幕
            <div class="row-padding">
              <el-input-number
                v-model="configure.keyPerson.copyKeyPersonBarrageNum"
                :controls-position="isPC ? 'right' : ''"
                :min="1"
                :max="4"
                size="mini"
              ></el-input-number
              >条， 延迟
              <el-input-number
                v-model="configure.keyPerson.copyKeyPersonBarrageDelay"
                :controls-position="isPC ? 'right' : ''"
                :min="1"
                :max="4"
                size="mini"
              ></el-input-number
              >秒
            </div>
          </div>
          <!-- <div class="row-padding">
            <el-switch
              v-model="configure.keyPerson.isSendByProtocol"
            ></el-switch
            >弹幕防丢弃
            <div class="row-padding">
              开启专属弹幕通道，人多的时候也不会丢弃大哥的欢迎、
              答谢等信息。（如果过频造成吞字，请关闭）
            </div>
          </div> -->
        </el-col>
      </el-row>
      <div class="reset-row">
        <el-button
          type="danger"
          size="small"
          @click="resetDefault('大哥名单', 'keyPerson')"
          >「大哥名单」恢复默认</el-button
        >
      </div>
    </div>
    <!-- 批量导入弹窗 -->
    <div
      class="pop mask"
      @click="isShowBatchImport = false"
      :class="{
        show: isShowBatchImport,
      }"
    >
      >
      <div class="box batch-import" @click.stop>
        <div class="title">
          <span>批量导入</span>
          <i class="close" @click="isShowBatchImport = false"></i>
        </div>
        <div class="content">
          <div class="block-tag">批量导入展示结果会自动去重已有的备注名单</div>
          <div class="row-padding">
            <el-radio v-model="batchImportRadio" label="0"
              >&nbsp;列出 今日送礼≥
              <el-input-number
                v-model="todayGiftNum"
                :controls-position="isPC ? 'right' : ''"
                size="mini"
              ></el-input-number
              >元</el-radio
            >&nbsp;
            <el-button
              v-show="batchImportRadio == 0"
              size="mini"
              type="primary"
              @click="getImportBatchList"
              >列出</el-button
            >
          </div>
          <div class="row-padding">
            <el-radio v-model="batchImportRadio" label="1"
              >&nbsp;列出 今日访客 贵族等级≥
              <el-select
                v-model="welcomeValue"
                placeholder="请选择"
                size="mini"
              >
                <el-option
                  v-for="item in welcomeConfig"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option> </el-select></el-radio
            >&nbsp;
            <el-button
              v-show="batchImportRadio == 1"
              size="mini"
              type="primary"
              @click="getImportBatchList"
              >列出</el-button
            >
          </div>
          <div class="row-padding">
            <el-radio v-model="batchImportRadio" label="2"
              >&nbsp;列出 周榜用户前
              <el-input-number
                v-model="ranking"
                :controls-position="isPC ? 'right' : ''"
                size="mini"
              ></el-input-number
              >名</el-radio
            >&nbsp;
            <el-button
              v-show="batchImportRadio == 2"
              size="mini"
              type="primary"
              @click="getImportBatchList"
              >列出</el-button
            >
          </div>
          <key-person-table
            ref="importBatch"
            :totalList="importBatchList"
            :currentList="currentPageImportBatchList"
            :baseList="baseImportBatchList"
            :ticket="ticket"
            totalListName="importBatchList"
            currentListName="currentPageImportBatchList"
            @changeList="changeList"
          ></key-person-table>
          <div class="row-padding actions-bottom">
            <el-button type="primary" @click="importBatch">导入</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getKeypersonList, addKeyPerson, searchKeyPerson } from "@/api/index";
import { configCommon } from "@/mixins/configCommon";
import { commonFuc } from "@/mixins/commonFuc";
import keyPersonTable from "@/components/keyPersonTable";
import personCard from "@/components/personCard";

export default {
  mixins: [configCommon, commonFuc],
  data() {
    return {
      //欢迎设定配置项
      welcomeConfig: require("@/assets/js/welcomeConfig.json"),
      consumeLevelConfig: require("@/assets/js/consumeLevelConfig.json"),
      showQueryMessage: false,
      queryMessage: "",
      keyPersonFilterValue: "",
      keyPersonList: [],
      totalCount: 0,
      totalPage: 0,
      baseList: [],
      pageSize: 5,
      pageNo: 1,
      //大哥尊称相关
      nickname: "",
      nicknameCustom: "",
      isSel: false,
      uid: "",
      addWelcomeBrother: "", // 欢迎 大哥名单 句式输入框
      restaurants: [],
      searchKeyPesonList: [],
      searchKeyPersonTimer: null,
      isShowSearchContent: false,
      // 批量导入
      isShowBatchImport: false,
      batchImportRadio: "0",
      todayGiftNum: 300,
      welcomeValue: 1,
      ranking: 300,
      importBatchList: [],
      currentPageImportBatchList: [],
      baseImportBatchList: [],
      modifyTimer: {},
      isLoading: false,
      scrollHandler: function () {},
      canSearch: true,
      searchCurrentPage: 0,
      cookie: "",
    };
  },
  props: {
    configure: {
      type: Object,
      default: null,
    },
    featureList: {
      type: Object,
      default: null,
    },
    ticket: {
      type: String,
      default: "",
    },
    configMainShow: {
      type: Object,
      default: () => {
        return {
          account: true,
          welcome: true,
          giftTks: true,
          guide: true,
          autoReply: true,
          AIChat: true,
          readText: true,
          autoBan: true,
          keyPerson: true,
          begGift: true,
          guessNum: true,
          duty: true,
          global: true,
        };
      },
    },
  },
  components: {
    keyPersonTable,
    personCard,
  },
  computed: {
    keyPersonListCopy() {
      return JSON.parse(JSON.stringify(this.keyPersonList));
    },
  },
  watch: {
    importBatchList: {
      handler: function (val, oldVal) {
        this.$refs.importBatch.setCurrentPageList();
        let isNew = true;
        val.forEach((data) => {
          isNew = true;
          if (!this.configure.keyPerson.list.length) {
            this.configure.keyPerson.list.unshift(data);
            return;
          }
          this.configure.keyPerson.list.forEach((subdata, index) => {
            if (data.nickname == subdata.nickname && data.uid == subdata.uid) {
              if (
                data.nicknameCustom != subdata.nicknameCustom ||
                data.welcomeTpl != subdata.welcomeTpl
              ) {
                this.configure.keyPerson.list.splice(index, 1, data);
              }
              isNew = false;
            }
            if (index == this.configure.keyPerson.list.length - 1) {
              if (isNew) {
                if (this.isShowBatchImport) {
                  this.configure.keyPerson.list.push(data);
                } else {
                  this.configure.keyPerson.list.unshift(data);
                }
              }
            }
          });
        });
      },
      deep: true,
    },
    keyPersonListCopy: {
      handler: function (val, oldVal) {
        console.log(val.length, oldVal.length);
        let data = JSON.parse(JSON.stringify(val));
        data.forEach((data, windex) => {
          oldVal.forEach((subdata, index) => {
            if (data.nickname == subdata.nickname && data.uid == subdata.uid) {
              console.log(data.nicknameCustom, subdata.nicknameCustom);
              if (
                data.nicknameCustom != subdata.nicknameCustom ||
                data.welcomeTpl != subdata.welcomeTpl
              ) {
                clearTimeout(this.modifyTimer[data.uid]);
                this.modifyTimer[data.uid] = setTimeout(() => {
                  this.addKeyPerson(data, true);
                }, 1000);
              }
            }
          });
        });
        // this.configure.keyPerson.list = data;
      },
      deep: true,
    },
  },
  mounted() {
    this.$refs.keyPerson.setCurrentPageList();
    this.scrollHandler = this.debounce(this.handlerScroll, 40, false);
    let accountList = localStorage["accountList"]
      ? JSON.parse(localStorage["accountList"])
      : {};
    if (
      accountList[this.$route.query.ticket] &&
      !this.isAccountExpire(accountList[this.$route.query.ticket].timestamp)
    ) {
      this.cookie = accountList[this.$route.query.ticket].cookies;
    }
  },
  methods: {
    isAccountExpire(timestamp) {
      // let r = await new Promise((res) => {
      //     setTimeout(() => { res() }, 0);
      // });
      let timeStamp = parseInt((+new Date() - timestamp) / 86400000) >= 7;
      if (timeStamp) {
        return true;
      } else {
        return false;
      }
    },
    handlerScroll() {
      let ele = this.$refs.scroll;
      let scrollTop = ele.scrollTop;
      let scrollHeight = ele.scrollHeight;
      let height = ele.clientHeight;
      //添加height 大于0,是因为，当他不show的时候，可能会有 height为0的情况，导致page 自动加1
      if (height > 0 && scrollTop + height + 50 > scrollHeight) {
        if (this.canSearch) {
          this.searchCurrentPage++;
          this.querySearch();
        }
      }
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.nickname.toLowerCase().indexOf(queryString.toLowerCase()) !== -1
        );
      };
    },
    async querySearch() {
      if (this.isLoading) return;
      if (!this.nickname) {
        this.searchKeyPesonList = [];
        this.isShowSearchContent = false;
        this.$message.warning("请输入要搜索的用户昵称或虎牙号");
        return;
      }
      this.isLoading = true;
      this.isShowSearchContent = true;
      searchKeyPerson({
        keywords: this.nickname,
        ticket: this.ticket,
        cookie: this.cookie,
        page: this.searchCurrentPage,
      })
        .then((res) => {
          this.isLoading = false;
          if (this.searchCurrentPage === 0) {
            this.searchKeyPesonList = [];
          }
          if (res.code == 0) {
            if (res.data.result.length) {
              let ret = res.data.result.map((item) => ({
                avatar: item.icon,
                nickname: item.nick,
                level: item.userLevel,
                uid: item.uid,
              }));
              this.searchKeyPesonList = this.searchKeyPesonList.concat(ret);
              this.canSearch = true;
            } else {
              this.canSearch = false;
            }
            if (!this.searchKeyPesonList.length) {
              this.isShowSearchContent = false;
              this.$message.error("该用户没找到，请确认用户昵称和虎牙号");
              this.canSearch = true;
            }
          } else {
            this.searchKeyPesonList = [];
            this.isShowSearchContent = false;
          }
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    searchFocus() {
      if (this.searchKeyPesonList.length && this.nickname.length) {
        this.isShowSearchContent = true;
      }
    },
    searchInput() {
      if (this.searchKeyPesonList.length && !this.nickname.length) {
        this.isShowSearchContent = false;
      }
      this.canSearch = true;
      this.searchCurrentPage = 0;
    },
    searchUser() {
      this.searchKeyPesonList = [];
      this.searchCurrentPage = 0;
      this.isShowSearchContent = false;
      this.canSearch = true;
      this.querySearch();
    },
    addKeyPersonList(item, showMessage = true) {
      let isNew = true;
      this.keyPersonList.forEach((val) => {
        if (val.nickname == item.nickname && val.uid == item.uid) {
          isNew = false;
        }
      });
      if (isNew) {
        this.addKeyPerson(item);
        // if (showMessage) {
        //   this.keyPersonList.unshift({
        //     nickname: item.nickname,
        //     nicknameCustom: item.nicknameCustom || item.nickname,
        //     uid: item.uid,
        //     level: item.level,
        //     nobel: item.nobel,
        //     welcomeTpl: item.welcomeTpl || "",
        //     checked: false,
        //   });
        //   this.$message({
        //     message: "添加成功",
        //     type: "success",
        //     duration: 500,
        //   });
        // } else {
        //   this.keyPersonList.push({
        //     nickname: item.nickname,
        //     nicknameCustom: item.nicknameCustom || item.nickname,
        //     uid: item.uid,
        //     level: item.level,
        //     nobel: item.nobel,
        //     welcomeTpl: item.welcomeTpl || "",
        //     checked: false,
        //   });
        // }
      } else {
        if (showMessage) {
          this.$message({
            message: "该大哥已配置",
            type: "warning",
            duration: 500,
          });
        }
      }
    }, //  大哥尊称添加
    getKeypersonList(pageNo, pageSize, filterText = "") {
      getKeypersonList(
        {
          ticket: this.ticket,
          page: pageNo,
          size: pageSize,
          keyword: filterText,
        },
        { notify: false }
      ).then((res) => {
        if (res.code === 0) {
          res.data.list.forEach((val) => {
            val.checked = false;
          });
          this.keyPersonList = res.data.list;
          this.totalCount = res.data.count;
          this.totalPage = res.data.total_page;
        } else {
          this.keyPersonList = [];
          this.totalCount = 0;
          this.totalPage = 0;
        }
      });
    },
    delNotice() {
      this.totalCount--;
    },
    changeList(data, list) {
      this[list] = data;
    },
    getImportBatchList() {
      this.baseImportBatchList = [
        {
          uid: 2493070676,
          nickname: "宝被-右手舞剑",
          level: 13,
          noble: 5,
          avatar:
            "https://huyaimg.msstatic.com/avatar/1082/96/2898a74b0b18f852d2cc5508c52a4d_180_135.jpg?1582637859",
        },
        {
          uid: "1863890973",
          nickname: "356、我爱你",
          level: 16,
          noble: 4,
          avatar:
            "https://huyaimg.msstatic.com/avatar/1007/e3/0baef5a7012b9dcd8c71d4b92e95da_180_135.jpg?1583145501",
        },
      ];
      this.baseImportBatchList.forEach((val) => {
        val.nicknameCustom = val.nickname;
      });
      this.importBatchList = JSON.parse(
        JSON.stringify(this.baseImportBatchList)
      );
    },
    importBatch() {
      this.baseImportBatchList.forEach((item, index) => {
        this.addKeyPersonList(item, false);
        if (index == this.baseImportBatchList.length - 1) {
          this.$message.success("批量添加成功");
          setTimeout(() => {
            this.importBatchList = [];
            this.isShowBatchImport = false;
          }, 0);
        }
      });
    },
    addKeyPerson(item, isModify = false) {
      addKeyPerson({
        ticket: this.ticket,
        uid: item.uid,
        nickname: item.nickname,
        nickname_custom: item.nicknameCustom || item.nickname,
        welcome_tpl: item.welcomeTpl || "",
      }).then((res) => {
        if (res.code == 0) {
          if (res.data && res.data.exists) {
            // 名单里已有这个大哥（可能不在当前页），后端只做了更新
            if (!isModify) {
              this.isShowSearchContent = false;
              this.$message({
                message: "该大哥已配置",
                type: "warning",
                duration: 500,
              });
            }
            return;
          }
          if (!isModify) {
            this.keyPersonList.unshift({
              nickname: item.nickname,
              nicknameCustom: item.nicknameCustom || item.nickname,
              uid: item.uid,
              level: item.level,
              noble_level: item.noble_level,
              welcomeTpl: item.welcomeTpl || "",
              add_from: 0,
              checked: false,
            });
            this.keyPersonList.forEach((val) => {
              val.checked = false;
            });
            this.isShowSearchContent = false;
            this.totalCount++;
            this.$refs.keyPerson.listAddForReset();
            this.$message({
              message: "添加成功",
              type: "success",
              duration: 500,
            });
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
